<template>
  <div class="main-content">
    <SectionTitle class="animate-target" v-animate-in :title="title"></SectionTitle>
    <img class="ctn-image animate-target" v-animate-in src="../../assets/images/p3-6/3-6-1.png" />
    <div class="ctn-text animate-target" v-animate-in>A pooled analysis of the FIDELO and FIGARO trials (FIDELITY) has shown reductions in cardiovascular events and kidney failure outcomes with finerenone treatment.<sup>1</sup></div>
    <img class="ctn-image animate-target" v-animate-in src="../../assets/images/p3-6/3-6-2.png" />
    <GoNext class="animate-target" v-animate-in href="/section3/3-7">Next</GoNext>
    <ContentNotice class="animate-target" v-animate-in :txt="noticeTxt"/>
  </div>
</template>

<script>
import SectionTitle from "../../components/SectionTitle";
import GoNext from "../../components/GoNext";
import ContentNotice from "../../components/ContentNotice";
import {mapState} from "vuex";
export default {
  name: "s3-6",
  components: {SectionTitle, GoNext, ContentNotice},
  computed:{
  },
  data(){
    return{
      noticeTxt:"*First HHF defined as first event after randomisation; <sup>#</sup>ESKD or an eGFR <15 ml/min/1.73 m<sup>2</sup>; events were classified as renal death if: (1) the patient died; (2) KRT had not been initiated despite being clinically indicated; and (3) there was no other likely cause of death; <sup>‡</sup>analysis for p-value not prespecified.<br/><div class='brs'></div>"
      +"CKD, chronic kidney disease; CV, cardiovascular; DKD, diabetic kidney disease;  eGR, estimated glomerular filtration rate; ESKD, end stage kidney disease; HHF, hospitalisation for heart failure; T2D, type 2 diabetes; UACR, urine albumin-to-creatinine ratio.<br/><div class='brs'></div>"
      +"References:<br/><div class='brs'></div>"
      +"1. Agarwal R, <i>et al. Eur Heart J</i> 2022;43:474-484.<br/>"
      +"2. Bakris GL, <i>et al</i>; FIDELIO DKD Investigators. N Engl J Med. 2020;383(23):2219-2229.<br/>"
      +"3. Pitt B, <i>et al. N Engl J Med</i>. 2021;385(24):2252-2263.",
      title:"FIGARO-DKD and FIDELIO-DKD investigated the effects of finerenone on kidney and CV outcomes in over 13,000 adults with CKD and T2D"
    }
  }
}
</script>

<style scoped>
@import "../../assets/css/section3/s3.css";
.ctn-image {
  width: 100%;
  margin-top: 40px;
}
.ctn-text {
  color: #10384F;
  font-size: 24px;
  font-weight: bold;
  margin-top: 40px;
}
</style>
